import script from "./CodeBeautifier.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeBeautifier.vue?vue&type=script&setup=true&lang=js"

import "./CodeBeautifier.vue?vue&type=style&index=0&id=277bef31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277bef31"]])

export default __exports__